import { calculateGiaTriConLai, calculateGiaTriKH1Ky, calculateNgayKetThucKh } from '../../../utils/calc-util';
import type { TableSelectedCell } from '@/components/custom/erp/input-table-v2';
import { useTableRows } from '@/components/custom/erp/input-table-v2';

export interface TSCCRow {
  uuid?: string | null;
  detail_uuid?: string | null;
  detail_line?: number | null;
  ma_ts?: string | null;
  ten_ts?: string | null;
  ma_lts?: string | null;
  ma_lts_data?: MuaHangRecord;
  ngay_mua?: string | null;
  ngay_kh0?: string | null;
  [key: string]: MuaHangRecord;
}

export type SelectedCellInfo = TableSelectedCell;

export function useTSCCRows(initialRows: TSCCRow[] = []) {
  const handleFieldValueChange = (row: TSCCRow, field: string, value: MuaHangRecord): Partial<TSCCRow> => {
    const extraFields: Partial<TSCCRow> = {};

    if (field === 'ngay_kh0' || field === 'so_ky_kh') {
      const startDate = field === 'ngay_kh0' ? value : row.ngay_kh0 || null;
      const periods = field === 'so_ky_kh' ? Number(value) || null : Number(row.so_ky_kh) || null;
      extraFields.ngay_kh_kt = calculateNgayKetThucKh(startDate, periods);
    }

    if (field === 'tien_nt' || field === 'nguyen_gia_nt' || field === 'so_ky_kh') {
      const nguyenGia =
        field === 'nguyen_gia_nt'
          ? Number(value) || 0
          : field === 'tien_nt'
            ? Number(value) || 0
            : Number(row.nguyen_gia_nt || row.tien_nt) || 0;
      const periods = field === 'so_ky_kh' ? Number(value) || 0 : Number(row.so_ky_kh) || 0;
      extraFields.gt_kh_ky_nt = calculateGiaTriKH1Ky(nguyenGia, periods);
    }

    if (field === 'tien_nt' || field === 'nguyen_gia_nt' || field === 'gt_da_kh_nt') {
      const nguyenGia =
        field === 'nguyen_gia_nt'
          ? Number(value) || 0
          : field === 'tien_nt'
            ? Number(value) || 0
            : Number(row.nguyen_gia_nt || row.tien_nt) || 0;
      const gtDaKH = field === 'gt_da_kh_nt' ? Number(value) || 0 : Number(row.gt_da_kh_nt) || 0;
      extraFields.gt_cl_nt = calculateGiaTriConLai(nguyenGia, gtDaKH);
    }

    return extraFields;
  };

  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<MuaHangRecord>({
    initialRows,
    defaultRows: 0,
    onFieldValueChange: handleFieldValueChange,
    defaultField: 'ma_ts'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
